import {connect} from 'react-redux';
import {MoveMenu as Component} from './MoveMenu';

import {
  setSolutionControlVisibility,
  setHeldObject,
  setSolutionHeld,
  setMoveMenu,
  showMoveMenu
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state, ownProps) {
  return {
    type: ownProps.type,
    connect: ownProps.connect,

    targetList: state.notebook.protocolSection.scene.targetList,
    display: state.notebook.protocolSection.scene.moveMenu.display,
    sceneScale: state.notebook.protocolSection.scene.sceneScale,
    userScale: state.notebook.protocolSection.scene.userScale,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    setSolutionControlVisibility: (data) => {
      dispatch(setSolutionControlVisibility(data))
    },
    setHeldObject: (data) => {
      dispatch(setHeldObject(data))
    },
    setSolutionHeld: (data) => {
      dispatch(setSolutionHeld(data))
    },
    setMoveMenu: (data) => {
      dispatch(setMoveMenu(data))
    },
    showMoveMenu: (data) => {
      dispatch(showMoveMenu(data))
    }
  };
}

export const MoveMenu = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
